module.exports = __webpack_public_path__ + "img/pictos-v2.10fcb518.png";